var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { showError } from "@spike/notifications-action";
import Axios from "axios";
import { INVOICES_CALCULATE_INVOICE_START_ACTION_TYPE, INVOICES_CALCULATE_INVOICE_SUCCESS_ACTION_TYPE, INVOICES_CREATE_DEPOSIT_INVOICE_START_ACTION_TYPE, INVOICES_CREATE_DEPOSIT_INVOICE_SUCCESS_ACTION_TYPE, INVOICES_ERROR_ACTION_TYPE, INVOICES_FETCH_TIPS_START_ACTION_TYPE, INVOICES_FETCH_TIPS_SUCCESS_ACTION_TYPE, INVOICES_GET_INVOICE_START_ACTION_TYPE, INVOICES_GET_INVOICE_SUCCESS_ACTION_TYPE, INVOICES_PREPARE_INVOICE_START_ACTION_TYPE, INVOICES_PREPARE_INVOICE_SUCCESS_ACTION_TYPE, INVOICES_RESET_ACTION_TYPE, INVOICES_SAVE_INVOICE_START_ACTION_TYPE, INVOICES_SAVE_INVOICE_SUCCESS_ACTION_TYPE, INVOICES_SAVE_TIP_START_ACTION_TYPE, INVOICES_SAVE_TIP_SUCCESS_ACTION_TYPE, INVOICES_UPDATE_INVOICE_START_ACTION_TYPE, INVOICES_UPDATE_INVOICE_SUCCESS_ACTION_TYPE, INVOICES_FETCH_ADMIN_INVOICES_START_ACTION_TYPE, INVOICES_FETCH_ADMIN_INVOICES_SUCCESS_ACTION_TYPE, } from "./InvoicesActionsTypes";
import { convertToAdminInvoice, convertToInvoice, convertToTip } from "./InvoicesConverter";
var invoicesUrl = "/invoices";
var prepareInvoiceUrl = "/prepare_invoice";
var createInvoiceUrl = "/create_invoice";
var createDepositInvoiceUrl = "/booking/deposit_invoice";
var adminInvoicesUrl = '/admin_invoices';
export var prepareInvoiceThunk = function (apiClientWrapper, booking, appointments) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(prepareInvoiceStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(prepareInvoiceUrl, "?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        invoice: {
                            marketplace_id: marketplaceId,
                            customer_id: booking.customer.id,
                            booking_id: booking.id,
                            uuid: apiClientWrapper.uuid(),
                            tip_amount: 0,
                            invoice_lines_attributes: appointments.map(function (appointment) {
                                return convertAppointmentToInvoiceLineDto(apiClientWrapper.uuid, appointment);
                            }),
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(prepareInvoiceSuccess(response.data, apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!Axios.isCancel(apiError_1)) {
                        console.error({ apiError: apiError_1 });
                        dispatch(error());
                        dispatch(showError("Error preparing invoice."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var updateInvoiceThunk = function (apiClientWrapper, invoice, appointments) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, response, apiError_2;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    dispatch(updateInvoiceStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(invoicesUrl, "/").concat(invoice.id, "?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        id: invoice.id,
                        marketplace_id: marketplaceId,
                        customer_id: (_a = invoice.customer) === null || _a === void 0 ? void 0 : _a.id,
                        booking_id: invoice.bookingId,
                        uuid: invoice.uuid,
                        tip_amount: ((_b = invoice.tip) === null || _b === void 0 ? void 0 : _b.percentage) === undefined ? ((_c = invoice.tip) === null || _c === void 0 ? void 0 : _c.amount) || 0 : undefined,
                        tip_percentage: (_d = invoice.tip) === null || _d === void 0 ? void 0 : _d.percentage,
                        invoice_lines_attributes: __spreadArray(__spreadArray(__spreadArray([], invoice.lines
                            .filter(function (line) { return appointments.some(function (appointment) { return appointment.id === line.appoitnmentId; }); })
                            .map(function (line) { return convertLineToDto(line); }), true), invoice.lines
                            .filter(function (line) { return line.appoitnmentId && !appointments.some(function (appointment) { return appointment.id === line.appoitnmentId; }); })
                            .map(function (appointment) { return ({ id: appointment.id, _destroy: true }); }), true), appointments
                            .filter(function (appointment) { return !invoice.lines.some(function (line) { return line.appoitnmentId === appointment.id; }); })
                            .map(function (appointment) { return convertAppointmentToInvoiceLineDto(apiClientWrapper.uuid, appointment); }), true),
                    };
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _e.sent();
                    dispatch(updateInvoiceSuccess(response.data, apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _e.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        console.error({ apiError: apiError_2 });
                        dispatch(error());
                        dispatch(showError("Error updating invoice."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var convertAppointmentToInvoiceLineDto = function (uuid, appointment) {
    return {
        uuid: uuid(),
        service_id: appointment.services[0].id,
        appointment_id: appointment.id,
        quantity: 1,
        discount_amount: 0,
        amount: appointment.total,
        description: appointment.services[0].name,
    };
};
export var prepareEmptyInvoiceThunk = function (apiClientWrapper, clientId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(prepareInvoiceStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(prepareInvoiceUrl, "?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        invoice: {
                            marketplace_id: marketplaceId,
                            uuid: apiClientWrapper.uuid(),
                            customer_id: clientId,
                            invoice_lines_attributes: [],
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(prepareInvoiceSuccess(response.data, apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        console.error({ apiError: apiError_3 });
                        dispatch(error());
                        dispatch(showError("Error preparing empty invoice."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var calculateInvoiceThunk = function (apiClientWrapper, invoice) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, marketplaceId, url, requestBody, response, apiError_4;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(calculateInvoiceStart(requestUuid));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(prepareInvoiceUrl, "?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        invoice: {
                            id: invoice.id,
                            marketplace_id: marketplaceId,
                            customer_id: (_a = invoice.customer) === null || _a === void 0 ? void 0 : _a.id,
                            booking_id: invoice.bookingId,
                            uuid: invoice.uuid,
                            tip_amount: ((_b = invoice.tip) === null || _b === void 0 ? void 0 : _b.percentage) === undefined ? ((_c = invoice.tip) === null || _c === void 0 ? void 0 : _c.amount) || 0 : undefined,
                            tip_percentage: (_d = invoice.tip) === null || _d === void 0 ? void 0 : _d.percentage,
                            number: invoice.number,
                            invoice_lines_attributes: invoice.lines.map(function (line) { return convertLineToDto(line); }),
                        },
                    };
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _e.sent();
                    if (getState().invoices.requestUuids.calculate === requestUuid) {
                        dispatch(calculateInvoiceSuccess(response.data, apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _e.sent();
                    if (!Axios.isCancel(apiError_4)) {
                        console.error({ apiError: apiError_4 });
                        dispatch(error());
                        dispatch(showError("Error calculating invoice."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveInvoiceThunk = function (apiClientWrapper, invoice) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiMethod, deletedLines, actualInvoice, getUrl, getResponse, invoiceLineIds_1, requestBody, response, apiError_5;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    dispatch(saveInvoiceStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = invoice.id
                        ? "".concat(invoicesUrl, "/").concat(invoice.id, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(createInvoiceUrl, "?marketplace_id=").concat(marketplaceId);
                    apiMethod = invoice.id ? apiClientWrapper.apiClient.patch : apiClientWrapper.apiClient.post;
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 6, , 7]);
                    deletedLines = [];
                    if (!invoice.id) return [3 /*break*/, 4];
                    actualInvoice = getState().invoices.invoice;
                    if (!((actualInvoice === null || actualInvoice === void 0 ? void 0 : actualInvoice.id) !== invoice.id)) return [3 /*break*/, 3];
                    getUrl = "".concat(invoicesUrl, "/").concat(invoice.id, "?marketplace_id=").concat(marketplaceId);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(getUrl, apiClientWrapper.requestConfig)];
                case 2:
                    getResponse = _e.sent();
                    actualInvoice = convertToInvoice(getResponse.data, apiClientWrapper.timeZone, apiClientWrapper.masterData);
                    _e.label = 3;
                case 3:
                    invoiceLineIds_1 = invoice.lines.filter(function (line) { return line.id; }).map(function (line) { return line.id; });
                    deletedLines = actualInvoice.lines
                        .filter(function (line) { return !invoiceLineIds_1.includes(line.id); })
                        .map(function (line) { return ({ id: line.id, _destroy: true }); });
                    _e.label = 4;
                case 4:
                    requestBody = {
                        invoice: {
                            id: invoice.id,
                            marketplace_id: marketplaceId,
                            customer_id: (_a = invoice.customer) === null || _a === void 0 ? void 0 : _a.id,
                            booking_id: invoice.bookingId,
                            uuid: invoice.uuid,
                            tip_amount: ((_b = invoice.tip) === null || _b === void 0 ? void 0 : _b.percentage) === undefined ? (_c = invoice.tip) === null || _c === void 0 ? void 0 : _c.amount : undefined,
                            tip_percentage: (_d = invoice.tip) === null || _d === void 0 ? void 0 : _d.percentage,
                            number: invoice.number,
                            invoice_lines_attributes: __spreadArray(__spreadArray([], invoice.lines.map(function (line) { return convertLineToDto(line); }), true), deletedLines, true),
                        },
                    };
                    return [4 /*yield*/, apiMethod(url, requestBody, apiClientWrapper.requestConfig)];
                case 5:
                    response = _e.sent();
                    dispatch(saveInvoiceSuccess(response.data, apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    return [3 /*break*/, 7];
                case 6:
                    apiError_5 = _e.sent();
                    if (!Axios.isCancel(apiError_5)) {
                        console.log(apiError_5);
                        dispatch(error());
                        dispatch(showError("Error saving invoice."));
                    }
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
};
var convertLineToDto = function (line) {
    var _a, _b, _c;
    return {
        id: line.id,
        uuid: line.uuid,
        service_id: (_a = line.service) === null || _a === void 0 ? void 0 : _a.id,
        appointment_id: line.appoitnmentId,
        quantity: line.quantity,
        discount_amount: ((_b = line.discount) === null || _b === void 0 ? void 0 : _b.amount) || null,
        discount_percentage: ((_c = line.discount) === null || _c === void 0 ? void 0 : _c.percentage) || null,
        amount: line.subtotal,
        description: line.description,
        business_product_id: line.productId,
        addon_service_id: line.addOnServiceId,
        tax_ids: line.taxes.map(function (tax) { return tax.id; }),
    };
};
export var getInvoiceThunk = function (apiClientWrapper, invoiceId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getInvoiceStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(invoicesUrl, "/").concat(invoiceId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getInvoiceSuccess(response.data, apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _a.sent();
                    if (!Axios.isCancel(apiError_6)) {
                        console.error({ apiError: apiError_6 });
                        dispatch(error());
                        dispatch(showError("Error getting invoice."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchTipsThunk = function (apiClientWrapper, invoiceId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchTipsStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(invoicesUrl, "/").concat(invoiceId, "/default_tips?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchTipsSuccess(response.data.map(function (dto) { return convertToTip(dto); })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_7 = _a.sent();
                    if (!Axios.isCancel(apiError_7)) {
                        console.error({ apiError: apiError_7 });
                        dispatch(error());
                        dispatch(showError("Error fetching tips."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveTipThunk = function (apiClientWrapper, invoiceId, amount, percentage, tipDirection) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, marketplaceId, url, requestBody, response, apiError_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(saveTipStart(requestUuid));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(invoicesUrl, "/").concat(invoiceId, "?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        invoice: {
                            id: invoiceId,
                            tip_amount: percentage === null ? amount : null,
                            tip_percentage: percentage,
                            tip_direction: tipDirection
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    if (requestUuid === getState().invoices.requestUuids.saveTip) {
                        dispatch(saveTipSuccess(response.data, apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _a.sent();
                    if (!Axios.isCancel(apiError_8)) {
                        console.error({ apiError: apiError_8 });
                        dispatch(error());
                        dispatch(showError("Error saving tip."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var createDepositInvoiceThunk = function (apiClientWrapper, bookingId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(createDepositInvoiceStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(createDepositInvoiceUrl, "/").concat(bookingId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, null, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(createDepositInvoiceSuccess(response.data, apiClientWrapper.timeZone, apiClientWrapper.masterData));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_9 = _a.sent();
                    if (!Axios.isCancel(apiError_9)) {
                        console.error({ apiError: apiError_9 });
                        dispatch(error());
                        dispatch(showError("Error creating deposit invoice."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchAdminInvoicesThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchAdminInvoicesStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(adminInvoicesUrl, "/?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchAdminInvoicesSuccess(response.data, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_10 = _a.sent();
                    if (!Axios.isCancel(apiError_10)) {
                        console.error({ apiError: apiError_10 });
                        dispatch(error());
                        dispatch(showError("Error fetching admin invoices."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var prepareInvoiceStart = function () {
    return { type: INVOICES_PREPARE_INVOICE_START_ACTION_TYPE };
};
export var prepareInvoiceSuccess = function (invoiceDto, timeZone, masterData) {
    return {
        type: INVOICES_PREPARE_INVOICE_SUCCESS_ACTION_TYPE,
        payload: {
            invoice: convertToInvoice(invoiceDto, timeZone, masterData),
        },
    };
};
var calculateInvoiceStart = function (requestUuid) {
    return {
        type: INVOICES_CALCULATE_INVOICE_START_ACTION_TYPE,
        payload: {
            requestUuid: requestUuid,
        },
    };
};
var calculateInvoiceSuccess = function (invoiceDto, timeZone, masterData) {
    return {
        type: INVOICES_CALCULATE_INVOICE_SUCCESS_ACTION_TYPE,
        payload: {
            invoice: convertToInvoice(invoiceDto, timeZone, masterData),
        },
    };
};
var saveInvoiceStart = function () {
    return { type: INVOICES_SAVE_INVOICE_START_ACTION_TYPE };
};
var saveInvoiceSuccess = function (invoiceDto, timeZone, masterData) {
    return {
        type: INVOICES_SAVE_INVOICE_SUCCESS_ACTION_TYPE,
        payload: {
            invoice: convertToInvoice(invoiceDto, timeZone, masterData),
        },
    };
};
var updateInvoiceStart = function () {
    return { type: INVOICES_UPDATE_INVOICE_START_ACTION_TYPE };
};
var updateInvoiceSuccess = function (invoiceDto, timeZone, masterData) {
    return {
        type: INVOICES_UPDATE_INVOICE_SUCCESS_ACTION_TYPE,
        payload: {
            invoice: convertToInvoice(invoiceDto, timeZone, masterData),
        },
    };
};
var getInvoiceStart = function () {
    return { type: INVOICES_GET_INVOICE_START_ACTION_TYPE };
};
var getInvoiceSuccess = function (invoiceDto, timeZone, masterData) {
    return {
        type: INVOICES_GET_INVOICE_SUCCESS_ACTION_TYPE,
        payload: {
            invoice: convertToInvoice(invoiceDto, timeZone, masterData),
        },
    };
};
var fetchTipsStart = function () {
    return { type: INVOICES_FETCH_TIPS_START_ACTION_TYPE };
};
var fetchTipsSuccess = function (tips) {
    return {
        type: INVOICES_FETCH_TIPS_SUCCESS_ACTION_TYPE,
        payload: {
            tips: tips,
        },
    };
};
var saveTipStart = function (requestUuid) {
    return {
        type: INVOICES_SAVE_TIP_START_ACTION_TYPE,
        payload: {
            requestUuid: requestUuid,
        },
    };
};
var saveTipSuccess = function (invoiceDto, timeZone, masterData) {
    return {
        type: INVOICES_SAVE_TIP_SUCCESS_ACTION_TYPE,
        payload: {
            invoice: convertToInvoice(invoiceDto, timeZone, masterData),
        },
    };
};
var createDepositInvoiceStart = function () {
    return { type: INVOICES_CREATE_DEPOSIT_INVOICE_START_ACTION_TYPE };
};
var createDepositInvoiceSuccess = function (invoiceDto, timeZone, masterData) {
    return {
        type: INVOICES_CREATE_DEPOSIT_INVOICE_SUCCESS_ACTION_TYPE,
        payload: {
            invoice: convertToInvoice(invoiceDto, timeZone, masterData),
        },
    };
};
var fetchAdminInvoicesStart = function () {
    return { type: INVOICES_FETCH_ADMIN_INVOICES_START_ACTION_TYPE };
};
var fetchAdminInvoicesSuccess = function (invoicesDto, timeZone) {
    return {
        type: INVOICES_FETCH_ADMIN_INVOICES_SUCCESS_ACTION_TYPE,
        payload: {
            invoices: invoicesDto.map(function (invoice) { return convertToAdminInvoice(invoice, timeZone); }),
        },
    };
};
export var reset = function () {
    return { type: INVOICES_RESET_ACTION_TYPE };
};
var error = function () {
    return {
        type: INVOICES_ERROR_ACTION_TYPE,
    };
};
